import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { GET_THE_APP_PATH, GET_THE_APP_URL } from '~/lib/appStores';
import { cn } from '~/lib/cn';

const STATIC_QR_SRC = '/images/shared/get-app-qr.svg';

/**
 * Scannable QR for `/get-the-app`. Encodes the **current origin** so local,
 * preview, and staging scans hit a host that actually serves the route.
 * Falls back to the production static SVG until the client URL is ready
 * (and on SSR). Production static assets still encode {@link GET_THE_APP_URL}.
 */
export function GetAppQr({
  className,
  alt = 'Scan to download the nsave app',
}: {
  className?: string;
  alt?: string;
}) {
  const [src, setSrc] = useState(STATIC_QR_SRC);

  useEffect(() => {
    const url = `${window.location.origin}${GET_THE_APP_PATH}`;
    // Production can keep using the checked-in SVG (same payload).
    if (url === GET_THE_APP_URL) {
      setSrc(STATIC_QR_SRC);
      return;
    }

    let cancelled = false;
    void QRCode.toDataURL(url, {
      margin: 1,
      width: 512,
      errorCorrectionLevel: 'M',
      color: { dark: '#000000', light: '#ffffff' },
    }).then((dataUrl) => {
      if (!cancelled) setSrc(dataUrl);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <img src={src} alt={alt} width={512} height={512} loading="lazy" className={cn(className)} />
  );
}
